
import React, {PropTypes} from 'react';
import {MainLayout} from 'components/layouts';
import {DemandDetail} from 'components/demands';
import {Demands} from 'api';

class DemandDetailContainer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      demand: null
    }
  }

  componentDidMount() {
    Demands.actions.get.request({
      id: this.props.match.params.id,
      filter: {
        include: ['user']
      }
    }).then(response => {
      this.setState({
        demand: response.data
      });
    });
  }

  render() {
    return (
      <MainLayout>
        <div>
          {this.state.demand &&
            <DemandDetail {...this.state.demand}/>
          }
        </div>
      </MainLayout>
    );
  }
}

export default DemandDetailContainer;



// WEBPACK FOOTER //
// ./pages/demands/DemandDetail.jsx